 
import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from 'components/Layout';
import LegalText from 'components/LegalText';

const LegalNoticePage = () => {
    const { t } = useTranslation();

    return (
        <Layout pageTitle={t('page.legal-notice.meta-title')}>
            <h1>{t('page.legal-notice.title')}</h1>
            <LegalText html={t('page.legal-notice.text')} />
        </Layout>
    );
};

export default LegalNoticePage;
